(() => {
  document.querySelectorAll('.nw-editorial .nw-article-table-wrap').forEach((wrapper, index) => {
    const table = wrapper.querySelector('table');
    if (!table || wrapper.dataset.scrollHint) return;
    wrapper.dataset.scrollHint = 'ready';

    const hint = document.createElement('p');
    hint.className = 'nw-article-table-hint';
    hint.id = `${wrapper.closest('[id]')?.id || 'article'}-table-hint-${index}`;
    hint.textContent = 'Swipe or scroll sideways to see every column. Keyboard: use the left and right arrow keys.';
    hint.hidden = true;
    wrapper.before(hint);

    const originalDescription = wrapper.getAttribute('aria-describedby') || '';
    const update = () => {
      const overflows = wrapper.scrollWidth > wrapper.clientWidth + 1;
      hint.hidden = !overflows;
      if (overflows) {
        wrapper.setAttribute('aria-describedby', [originalDescription, hint.id].filter(Boolean).join(' '));
      } else if (originalDescription) {
        wrapper.setAttribute('aria-describedby', originalDescription);
      } else {
        wrapper.removeAttribute('aria-describedby');
      }
    };

    // Existing authored regions keep their names; keyboard scrolling stays native.
    if (!wrapper.hasAttribute('tabindex')) wrapper.tabIndex = 0;
    update();
    if (typeof ResizeObserver === 'function') {
      const observer = new ResizeObserver(update);
      observer.observe(wrapper);
      observer.observe(table);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }
  });
})();
